const SHARDS = [
  { className: "left-[4%] top-[12%] h-44 w-24", rotate: -18, depth: 0.12, drift: 12, opacity: 0.45, delay: "0s" },
  { className: "left-[18%] top-[64%] h-24 w-56", rotate: 10, depth: -0.08, drift: 18, opacity: 0.32, delay: "-4s" },
  { className: "left-[42%] top-[8%] h-28 w-72", rotate: -8, depth: 0.18, drift: 20, opacity: 0.3, delay: "-8s" },
  { className: "right-[22%] top-[38%] h-56 w-32", rotate: 22, depth: -0.16, drift: 24, opacity: 0.48, delay: "-12s" },
  { className: "right-[5%] top-[10%] h-36 w-64", rotate: 14, depth: 0.1, drift: 16, opacity: 0.38, delay: "-16s" },
  { className: "right-[10%] bottom-[8%] h-28 w-80", rotate: -12, depth: 0.22, drift: 28, opacity: 0.26, delay: "-20s" },
];

export default function ParallaxGlassField({ className = "", density = "hero" }) {
  return (
    <div
      className={`parallax-field ${density === "light" ? "opacity-60" : ""} ${className}`}
      data-parallax-field
      aria-hidden="true"
    >
      <div className="absolute inset-0 grid-bg opacity-35 [mask-image:linear-gradient(to_bottom,black_4%,transparent_78%)]" />
      <span className="light-band light-band-a" data-light-band />
      <span className="light-band light-band-b" data-light-band />
      {SHARDS.map((shard, index) => (
        <span
          key={index}
          data-glass-shard
          data-depth={shard.depth}
          data-rotate={shard.rotate}
          className={`glass-shard absolute ${shard.className}`}
          style={{
            "--shard-opacity": shard.opacity,
            "--shard-delay": shard.delay,
            transform: `rotate(${shard.rotate}deg)`,
          }}
        />
      ))}
    </div>
  );
}
